import { useVideoDownlinkPolicy } from "../hooks/useVideoDownlinkPolicy";
import { useDeviceHotPlug } from "../hooks/useDeviceHotPlug";
import { useIPhoneMicToast } from "../hooks/useIPhoneMicToast";

export function VideoTileGridEffects() {
  useVideoDownlinkPolicy();
  useDeviceHotPlug();
  useIPhoneMicToast();
  return null;
}
